module.exports = __webpack_public_path__ + "img/finial-vertex.539e95d8.jpg";